<template>
  <div>
    <v-layout wrap justify-center mt-12>
      <v-flex xs12 sm10>
        <v-layout wrap justify-center>
          <v-flex xs12 sm11>
            <h1 v-if="items.length === 1">{{ $t('a') }}</h1>
            <h1 v-if="items.length >= 2">{{ $t('b') }}</h1>
          </v-flex>
        </v-layout>
        <v-layout wrap mt-10 mb-4 justify-center>
          <v-flex xs12 text-center mb-3>
            <img :src="images.main" height="180px"/>
          </v-flex>
          <v-flex xs11 sm8>
            <v-layout wrap>
              <v-flex xs12>
                <div v-if="isFetchingDossiers" class="mt-3">
                  <v-layout wrap justify-center>
                    <v-flex xs8 mt-4>
                      <v-progress-linear indeterminate color="primary"></v-progress-linear>
                    </v-flex>
                  </v-layout>
                </div>
                <div v-else>
                  <v-layout wrap mt-6>
                    <v-flex xs12 v-for="(item, key) in items" :key="key">
                      <v-card class="px-8 py-4">
                        <v-layout wrap>
                          <v-flex xs6>
                            <h3 :class="{ 'mt-5 mb-4': !item.invitingUser.email }">{{ item.companyName }}</h3>
                            <small v-if="item.invitingUser.email">
                              <div>
                                <div>{{ $t('c') }} {{ [item.invitingUser.firstName, item.invitingUser.lastName].filter(Boolean).join(' ') }}.</div>
                                <div>{{ item.invitingUser.email }}</div>
                              </div>
                            </small>
                          </v-flex>
                          
                          
                          <v-flex xs6>
                            <v-layout text-end wrap justify-space-around class="pl-12">
                              <v-flex xs6>
                                <v-btn v-if="item.dossier.status === 'done'" small class="secondary pl-3 pr-4 mt-4" @click="downloadDossier(item.dossier)">
                                  <v-icon small class="mr-2">mdi-download</v-icon>&nbsp;
                                  <span>{{ $t('j') }}</span>
                                </v-btn>
                              </v-flex>
                              <v-flex xs6>
                                <v-btn v-if="item.dossier.sourceUrl" small :to="`/consultant/dossiers/${item.dossier.id}/edit`" outlined class="mt-4">
                                  <v-icon small class="mr-2">mdi-pen</v-icon>
                                  {{ $t('d') }}
                                </v-btn>
                                <v-btn v-else :to="`/consultant/dossiers/${item.dossier.id}/upload-cv`" color="secondary" class="mt-3 mr-3">{{ $t('e') }}</v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                        </v-layout>
                        <v-layout wrap mt-3 v-if="item.dossier.sourceUrl">
                          <v-flex xs12 text-center>
                            <div>
                              <v-icon class="mr-2 secondary--text">mdi-check</v-icon>
                            </div>
                            <small>
                              <div><b>{{ $t('f') }} {{ item.companyName }}</b></div>
                              <div>{{ $t('f2') }}</div>
                            </small>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap v-if="items.length === 0">
                    <v-flex xs12 text-center>
                      <small>
                        {{ $t('i') }}
                      </small>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div style="position: fixed; bottom: 10px; width: 100%">
      <v-layout wrap>
        <v-flex xs12 text-center>
          <small>
            <div>{{ $t('g') }}</div>
            <div>{{ $t('h') }} <a href="mailto:martin@esnwebservices.com">martin@esnwebservices.com</a></div>
          </small>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from "vuex";

export default {
  data: () => ({
    isFetchingDossiers: false,
    items: [],
    images: {
      main: require('@/assets/app/images/personal_data__flatline.svg'),
    },
  }),
  async mounted() {
    this.isFetchingDossiers = true
    if (this.$route.query.setUserLocale) {
      this.$functions.httpsCallable('updateUser')({
        locale: this.$route.query.setUserLocale
      })
    }
    if (this.user.loggedIn && this.user.data && this.user.data.createdAt && !('isConsultant' in this.user.data)) {
      await this.$functions.httpsCallable('setUpIsConsultantOrNot')({
        isConsultant: true
      })
    }
    this.items = (await this.$functions.httpsCallable('consultantGetMyDossiers')()).data.items
    await this.$functions.httpsCallable('setCustomClaimOfDossierIds')()
    this.isFetchingDossiers = false
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  methods: {
    async downloadDossier(dossier) {
      const url = await this.$storage.ref(dossier.downloadUrl).getDownloadURL()
      this.haveUserDownloadFile(url, dossier)
    },
    haveUserDownloadFile(url, dossier) {
      return new Promise(resolve => {
        axios({
          method: 'get',
          url,
          responseType: 'arraybuffer',
        })
        .then((response) => {
          this.forceFileDownload(response, dossier)
        })
        .then(() => {
          resolve()
        })
        .catch(() => console.log('error occured'))
      })
    },
    forceFileDownload(response, dossier) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.style.display = 'none';
      link.href = url
      let fileName;
      fileName = ['CV', dossier.fullName].filter(Boolean).join(' ').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, ' ') + '.docx'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Votre dossier de compétences",
    "b": "Vos dossiers de compétences",
    "c": "Invité par",
    "d": "Éditer",
    "e": "Uploader mon CV",
    "f": "Les informations de ce dossier sont partagées avec",
    "f2": "Les managers de cette entreprise peuvent directement télécharger votre dossier depuis leur compte.",
    "g": "Un feedback ?",
    "h": "Contactez-nous à",
    "i": "Vous n'avez pas reçu d'invitation à créer votre dossier.",
    "j": "Télécharger"
  },
  "en": {
    "a": "Your CV",
    "b": "Your CVs",
    "c": "Invited by",
    "d": "Edit",
    "e": "Upload my CV",
    "f": "This CV is shared with",
    "f2": "The managers of this company can directly download the new document from their account.",
    "g": "A feedback ?",
    "h": "Contact us at",
    "i": "You have not received any invitation to create your CV yet.",
    "j": "Download"
  }
}
</i18n>
